// extracted by mini-css-extract-plugin
export default {"date-picker":"BaseDatepicker-ie0rl__date-picker"};